module.exports = __webpack_public_path__ + "img/f776456.svg";